import React from 'react'

export default function TodaysSalesStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .card-container {
          border-radius: 15px;
          display: flex;
          color: white;
          background-color: black;
          padding: 20px;
          width: 40%;
          justify-content: space-between;
        }
        .title-container {
          display: flex;
          flex-direction: column;
          text-align: left;
        }
        .date-container {
          color: darkgrey;
          display: flex;
          flex-direction: column;
          text-align: right;
        }

        .products-sold-table-container {
          font-size: 1rem;
          display: flex;
          /*background-color: whitesmoke;*/
          border: solid 0.5px #888;
          width: 80%;
          padding: 10px;
          box-shadow: 2px 3px #888;
        }
        .products-sold-table th {
          padding: 7px 2px;
        }
        .products-sold-table td {
          padding: 2px;
        }
        .products-sold-table {
          width: 100%;
          border-spacing: 0;
        }
        .products-sold-table th:nth-child(1), .products-sold-table td:nth-child(1) { width: 45%; }
        .products-sold-table th:nth-child(2), .products-sold-table td:nth-child(2) { width: 25%; }
        .products-sold-table th:nth-child(3), .products-sold-table td:nth-child(3) { width: 15%; }
        .products-sold-table th:nth-child(4), .products-sold-table td:nth-child(4) { width: 15%; }
        .products-sold-table th {
          border-top: solid 0.5px lightgrey;
          border-bottom: solid 0.5px lightgrey;
        }

        /*.timezone-wrapper { font-size: 0.8rem; }*/

      `}
      </style>
    </React.Fragment>
  )
}
